import { ReactNode } from "react";
import { Grid } from "src/lib/components/basics";

interface IMessageFooterProps {
    /** Which edge the row packs against. The caller decides — this component has no opinion on sent vs received. */
    justify: "flex-start" | "flex-end";
    /** Already assembled in the order the caller wants it displayed, left to right. */
    children: ReactNode;
}

/** A generic row for whatever sits below a message (timestamp, actions...) — packed to one edge, in the given order. */
const MessageFooter = ({ justify, children }: IMessageFooterProps) => (
    <Grid container className="chat-message-footer" justifyContent={justify} alignItems="center" wrap="nowrap" gap={1}>
        {children}
    </Grid>
);

export { MessageFooter };
